import React from 'react';
import { getTeamMemberRoles } from 'api/group';
import { TRole } from 'types/group';

let globalRoles: TRole[] = [];
let globalPromise: Promise<TRole[]> | null = null;
const globalListeners: Set<() => void> = new Set();

// [
//     {
//         "id": 16,
//         "name": "GROUP_PROVIDER",
//         "createTime": "2026-05-10T08:46:34.000+00:00",
//         "createBy": null,
//         "updateTime": null,
//         "updateBy": null
//     },
//     {
//         "id": 17,
//         "name": "GROUP_ADMINISTRATIVE_ASSISTANT",
//         "createTime": "2026-05-10T08:46:34.000+00:00",
//         "createBy": null,
//         "updateTime": null,
//         "updateBy": null
//     },
//     {
//         "id": 18,
//         "name": "GROUP_CLINICAL_ASSISTANT",
//         "createTime": "2026-05-10T08:46:34.000+00:00",
//         "createBy": null,
//         "updateTime": null,
//         "updateBy": null
//     },
//     {
//         "id": 19,
//         "name": "GROUP_PRACTICE_MANAGER",
//         "createTime": "2026-05-10T08:46:34.000+00:00",
//         "createBy": null,
//         "updateTime": null,
//         "updateBy": null
//     }
// ]

const notifyListeners = () => {
    globalListeners.forEach((fn) => fn());
};

const fetchRoles = async (): Promise<TRole[]> => {
    try {
        const result = await getTeamMemberRoles();
        if (!result.error) {
            globalRoles = result?.data?.data || [];
        }
    } catch (e) {
        console.error(e);
    }
    globalPromise = null;
    notifyListeners();
    return globalRoles;
};

const ensureFetched = () => {
    if (globalRoles.length > 0) return;
    if (!globalPromise) {
        globalPromise = fetchRoles();
    }
};

const useAllPlatformRoles = (enabled = true): [TRole[], boolean, () => void] => {
    const [, forceUpdate] = React.useReducer((x: number) => x + 1, 0);
    const loading = !!globalPromise;

    React.useEffect(() => {
        if (!enabled) return;
        globalListeners.add(forceUpdate);
        ensureFetched();
        return () => {
            globalListeners.delete(forceUpdate);
        };
    }, [enabled]);

    const refetch = React.useCallback(() => {
        globalPromise = fetchRoles();
        notifyListeners();
    }, []);

    return [globalRoles, loading, refetch];
};

export default useAllPlatformRoles;
